//resources/js/plugins/index.js
import Vue from "vue";
import "./auth";
import "./remoteForceDbHandler";

import ElementUI from "element-ui";
import moment from "moment";
import { Timeline } from "vue2vis";
import locale from "element-ui/lib/locale/lang/en";
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";
import store from "~/store";
import VueScrollTo from "vue-scrollto"; //https://github.com/rigor789/vue-scrollto
import DrawerLayout from "vue-drawer-layout";
import * as api from "~/api/resource";
import Quasar from "quasar";
import VueSignaturePad from "vue-signature-pad";
import currency from "currency.js";

const dev_mode = window.location.host === "kriton.safecontrol.sofar";
window._log_ = (() => {
  if (dev_mode) {
    return console.log;
  } else return () => {
  };
})();
Vue.use(VueSignaturePad);
Vue.use(Quasar);
Vue.use(DrawerLayout);

// see docs for available options
const datepickerOptions = {};
const countryTzUTCoffset = 180;//Companies TZ were services are provided

function errorMessage(message, e) {
  console.error(message, typeof e == "undefined" ? "" : e);
  //alert(message);
}

function checkMediaPermissions() {
  if (location.protocol === "https:") {
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    if (navigator.getUserMedia) {
      navigator.getUserMedia({ audio: true, video: true }, function(stream) {
        document.querySelector("video").src = window.URL.createObjectURL(stream);
        var mediaStreamTrack = stream.getVideoTracks()[0];
        if (typeof mediaStreamTrack != "undefined") {
          mediaStreamTrack.onended = function() {//for Chrome.
            errorMessage("Your webcam is busy!");
          };
        } else errorMessage("Permission denied!");
      }, function(e) {
        var message;
        switch (e.name) {
          case "NotFoundError":
          case "DevicesNotFoundError":
            message = "Please setup your webcam first.";
            break;
          case "SourceUnavailableError":
            message = "Your webcam is busy";
            break;
          case "PermissionDeniedError":
          case "SecurityError":
            message = "Permission denied!";
            break;
          default:
            errorMessage("Reeeejected!", e);
            return;
        }
        errorMessage(message);
      });
    } else errorMessage("Uncompatible browser!");
  } else errorMessage("Use https protocol for open this page.");
}

// setInterval(() => {
//     _log_('scheduleMeasurement', Math.floor(performance.memory.usedJSHeapSize / (1024 * 1024)))
// }, 1000)

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.component("timeline", Timeline);
Vue.use(ElementUI, { size: "small", zIndex: 3000, locale });
Vue.directive("d-fill-height", {
  inserted: function(inputDom, bind) {
    _log_("set theight i:", inputDom, bind);
    let fromBottom = 0,
      watcher = window;
    if (bind && bind.value === false) return;

    ///helpers
    function isTouchDevice() {
      try {
        document.createEvent("TouchEvent");
        return true;
      } catch (e) {
        return false;
      }
    }

    function resizeELement(inputDom, bottomOffset) {
      if (!bottomOffset) bottomOffset = 0;
      var $this = $(inputDom),
        hh = $(window)
          .height();

      var offsetparams = $this.offset(),
        nH = hh - offsetparams.top - bottomOffset;

      $this.css({
        height: nH,
        overflow: "auto"
      });
      _log_("set theight:", hh, nH, offsetparams.top);
    }

    ///helpers end
    if (bind.value && bind.value.bottom) fromBottom = bind.value.bottom;
    if (bind.value && bind.value.watcher) {
      inputDom.dataset.watcher = bind.value.watcher;
      inputDom.dataset.lastHeight = $(inputDom.dataset.watcher)
        .height();
    }
    if (bind.value && !bind.value.bottom && !bind.value.watcher)
      fromBottom = bind.value;
    if (!isTouchDevice()) {
      resizeELement(inputDom, fromBottom);
      //   _log_('go for:' + watcher)
      $(window)
        .resize(function(e) {
          clearTimeout($.data(inputDom, "resizeTimer"));
          $.data(
            inputDom,
            "resizeTimer",
            setTimeout(function() {
              var go = true;
              if (inputDom.dataset.watcher) {
                var dh = $(inputDom.dataset.watcher)
                  .height();
                if (dh == inputDom.dataset.lastHeight) go = false;
                else inputDom.dataset.lastHeight = dh;
              }
              if (go) resizeELement(inputDom, fromBottom);
            }, 200)
          );
        });
    }
  }
});

function isTouchDevice() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e) {
    return false;
  }
}

function adjustHeightToBottom(element) {
  if (!element || !(element instanceof HTMLElement)) {
    throw new Error("Invalid element provided.");
  }

  const updateHeight = () => {
    const viewportHeight = window.innerHeight;
    const elementRect = element.getBoundingClientRect();
    const elementTop = elementRect.top;
    const requiredHeight = viewportHeight - elementTop;
    _log_("fill-height updateHeight i:", requiredHeight);
    element.style.height = requiredHeight + "px";
  };

  // Initial height adjustment
  updateHeight();

  // Adjust height on window resize
  window.addEventListener("resize", updateHeight);

  // Observe changes to the DOM to adjust height dynamically
  const observer = new MutationObserver(updateHeight);
  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true
  });

  // Observe changes to the element's size
  const resizeObserver = new ResizeObserver(updateHeight);
  resizeObserver.observe(element);
}

Vue.directive("fill-height", {
  inserted: function(inputDom, bind) {
    _log_("fill-height theight i:", bind);
    // function resizeELement(inputDom, bottomOffset) {
    //     if (!bottomOffset) bottomOffset = 0;
    //     var $this = $(inputDom),
    //         hh = $(window)
    //             .height();
    //
    //     var offsetparams = $this.offset(),
    //         nH = hh - offsetparams.top - bottomOffset;
    //
    //     $this.css({
    //         height: nH,
    //         overflow: "auto",
    //     });
    //     _log_("set theight:", hh, nH, offsetparams.top);
    // }

    if (bind && bind.value === false) return;
    inputDom.parentElement.style.display = "flex";
    if (bind.value?.container === "column" || bind.value?.container === "row")
      inputDom.parentElement.style.flexDirection = bind.value.container;
    else if (bind.value === "column" || bind.value === "row")
      inputDom.parentElement.style.flexDirection = bind.value;
    else
      inputDom.parentElement.style.flexDirection = "column";
    if (bind.value?.topOffset)
      inputDom.style.maxHeight = "calc(100vh - " + bind.value.topOffset + ")";
    inputDom.parentElement.style.width = "100%";
    if (!bind.value?.noStyles) {
      inputDom.style.flexGrow = "1";
      inputDom.style.width = "100%";
      inputDom.style.overflow = "auto";
    }
    if (isTouchDevice())
      inputDom.style.minHeight = "80vh";
    else if (!inputDom.style.minHeight) inputDom.style.minHeight = "30vh";
    if (bind && bind.value === "dynamic")
      adjustHeightToBottom(inputDom);
    return;

    let fromBottom = 0,
      watcher = window;


    ///helpers


    ///helpers end
    if (bind.value && bind.value.bottom) fromBottom = bind.value.bottom;
    if (bind.value && bind.value.watcher) {
      inputDom.dataset.watcher = bind.value.watcher;
      inputDom.dataset.lastHeight = $(inputDom.dataset.watcher)
        .height();
    }
    if (bind.value && !bind.value.bottom && !bind.value.watcher)
      fromBottom = bind.value;
    if (!isTouchDevice()) {
      resizeELement(inputDom, fromBottom);
      //   _log_('go for:' + watcher)
      $(window)
        .resize(function(e) {
          clearTimeout($.data(inputDom, "resizeTimer"));
          $.data(
            inputDom,
            "resizeTimer",
            setTimeout(function() {
              var go = true;
              if (inputDom.dataset.watcher) {
                var dh = $(inputDom.dataset.watcher)
                  .height();
                if (dh == inputDom.dataset.lastHeight) go = false;
                else inputDom.dataset.lastHeight = dh;
              }
              if (go) resizeELement(inputDom, fromBottom);
            }, 200)
          );
        });
    }
  }
});
Vue.filter("2dcm", function(value) {
  if (!value) return "";

  return parseFloat(value)
    .toFixed(2);
});

Vue.use(VueScrollTo);

Vue.mixin({
  data() {
    return {

      lexicon: {
        receipt: "ΑΠΥ",
        invoice: "ΤΙΜΟΛΟΓΙΟ",
        pistotiko: "ΠΙΣΤΩΤΙΚΟ"
      },
      paymentTrans: {
        cash: "Μετρητα",
        bank: "Τραπεζα",
        visa: "POS",
        invoiced: "Τιμολογιο",
        bank_deposit: "Τραπεζ.Κατάθ.",
        stock: "Πιστοπτικα",
        other: "Αλλο",
        any: "..."
      },
      // themeCtx:'dark',//sunny
      clientConf: window.Receipt.configuration,
      cachedSnapShots: {},
      ctx: null
    };
  },
  watch: {
    "$route.params.direction": {
      handler(v, vo) {
        // _log_("go ahead/direction/", v);
        if (v && v != vo) this.ctx = v;
      },
      immediate: true
    }
  },
  computed: {
    navLeftIcon: {
      get() {
        return this.$store.state.helpers.topLeftIcon;
      },
      set(v) {
        this.$store.commit("helpers/topLeftIcon", v);
      }
    },
    themeCtx() {
      return this.$userProfile.theme ? this.$userProfile.theme : "dark";//sunny
    },
    $mobileDevice() {
      _log_("go ahead/$mobileDevice/", this.$route.name);
      return this.isMobileDevice();
    },
    bookingRange: {
      set(v) {
        // _log_("go ahead/bookingRange/", v);
        // if (this.loading) return;
        let q = JSON.parse(JSON.stringify(this.$route.query));
        if (!v) {
          q.timerange_from = null;
          q.timerange_to = null;
        }
        if (v[0]) q.timerange_from = v[0];
        else q.timerange_from = null;
        if (v[1]) q.timerange_to = v[1];
        else q.timerange_to = null;

        this.routeGo(
          {
            query: q
          },
          true
        );

        return;
      },
      get() {
        _log_("go ahead/bookingRange/", this.$route.query);
        let o = [];
        if (this.$route.query.timerange_from) {
          o.push(this.$route.query.timerange_from);
          if (this.$route.query.timerange_to)
            o.push(this.$route.query.timerange_to);
        }

        return o.length ? o : null;
      }
    },
    $dateRangeArr: {
      set(v) {
        // _log_("go ahead/bookingRange/", v);
        // if (this.loading) return;
        let q = JSON.parse(JSON.stringify(this.$route.query));
        if (!v) {
          q.timerange_from = null;
          q.timerange_to = null;
        }
        if (v[0]) q.timerange_from = v[0];
        else q.timerange_from = null;
        if (v[1]) q.timerange_to = v[1];
        else q.timerange_to = null;

        this.routeGo(
          {
            query: q
          },
          true
        );

        return;
      },
      get() {
        // _log_("go ahead/bookingRange/", this.$route.query);
        let o = [];
        if (this.$route.query.timerange_from !== undefined) {
          o.push(this.$route.query.timerange_from);
          if (this.$route.query.timerange_to !== undefined)
            o.push(this.$route.query.timerange_to);
        }

        return o.length ? o : null;
      }
    },
    isbusiness() {
      // _log_("go ahead/direction/", this.$route.name);
      if (
        this.$route.name == "ManageInvoice" ||
        this.$route.name == "timologiera" ||
        this.$route.name == "timologio" ||
        this.$route.name == "dashboard"
      )
        return 1;
      return this.$route.params.direction == "in" ? 1 : 0;
    },
    issapplier() {
      if (
        this.$route.name == "timologiera" ||
        this.$route.name == "timologio" ||
        this.$route.name == "dashboard"
      )
        return 0;
      return this.$route.params.direction == "in" ? 0 : 1;
    },
    userDomain() {
      if (!window.Travel.wdb) return null;
      return window.Travel.wdb.replace("_", "");
    },
    $userProfile() {
      _log_("$userProfile", this.userDomain);
      const hardData = this.$store.state.configuration.profile[this.userDomain] ? this.$store.state.configuration.profile[this.userDomain] : {};
      const servData = this.$store.state.configuration.loggedUser ? this.$store.state.configuration.loggedUser : {};
      return { ...hardData, ...servData };
    }

  },
  // async created() {
  //   if (!store.state.loggedUser) {
  //     this.$set(store.state, "loggedUser", true);
  //     const results = await api.fetchProcessor("gears/userinfo");

  //     _log_("loggedUser..", results);
  //     this.$set(store.state, "loggedUser", results);
  //   }
  // },
  methods: {
    countDateDistance(dayA, dayZ, unite = "days") {
      let a = moment(dayA), b = moment(dayZ);
      return Math.abs(a.diff(b, unite));
    },
    toggleLefPanel(state) {
      this.$store.commit("helpers/toggleLefPanel", state);
    },
    toggleLefPanelResponsive(state) {
      if (window.innerWidth <= 720)
        this.$store.commit("helpers/toggleLefPanel", state);
    },
    displayVal(val, colDefs, row) {
      const vm = this;

      if (!row || (row.idx && (row.idx + "").indexOf("gap") === 0)) return;
      if (colDefs.formatterType == "unxToDate") return this.formatDate(val);
      else if (colDefs.formatter) {
        return colDefs.formatter(val, colDefs, row, vm, this.tableData);
      }
      if (val === null || val === undefined) return "&nbsp;";
      if (colDefs.labelProp) val = row(colDefs.labelProp);

      const editor = colDefs.editorcomponent;
      if (editor)
        switch (editor.is) {
          case "s-select":
            if (!val || val == "" || val == 0) return "&nbsp;";
            if (editor.valueProp == "raw") return val;
            let avOptions = null;
            if (editor.optionsRepo) {
              avOptions = this.getList(editor.optionsRepo);
            } else avOptions = editor.options;

            var q = {};
            q[editor.valueProp] = val + "";
            var o = _.find(avOptions, q);
            if (o) return o[editor.labelProp];
            else {
              q[editor.valueProp] = val;
              o = _.find(avOptions, q);
              if (o) return o[editor.labelProp];
            }
            return "?" + val;
            break;

          default:
            break;
        }

      return val && val != "" ? val : "<div> &nbsp;</div>";
    },
    firstCapital(str) {
      if (!str) return str;
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    makeBookingLink(bk) {
      return "/spa/#/tripsmanager/" + bk.tripType + "/tripadmin/" + bk.tripid + "/bookings/booking/" + bk.bk_id + (bk.tripDateTime ? "?timerange_from=" + this.dateFromUnxTime(bk.tripDateTime - 24 * 60 * 60) + "&timerange_to=" + this.dateFromUnxTime(bk.tripDateTime + 24 * 60 * 60) : "");
      ///spa/#/tripsmanager/excrs/tripadmin/12159/bookings/booking/378712?bookingid=378712
    },
    _dbg(e) {
      _log_("___DBG:", e);
    },
    async setSetting(key, val, onContext) {
      const { data } = await api.getModxProcessor(
        "gears/appsettings",
        { key: key, set: JSON.stringify(val), ctxapp: onContext }
      );
    },
    async getSetting(key, onContext) {
      const data = await api.getModxProcessor(
        "gears/appsettings",
        { key: key, ctxapp: onContext }
      );
      _log_("getSetting", data);
      return data;
    },
    async deleteSetting(key, onContext) {
      const data = await api.getModxProcessor(
        "gears/appsettings",
        { key: key, ctxapp: onContext, delete: true }
      );
      // this.predifinedConfigurations.splice(idx-1,1)
      // _log_('getSetting', data)
      return data;
    },
    console_log_hidden() {
    },
    async getLoggedUser(context) {
      const dt = await store.dispatch("configuration/getLoggedUser", context);
      // _log_("loggedUserdtdtdtdt..", dt);
      return dt;
    },
    hasValues(obj, key) {
      // _log_("check siz " + obj);
      if (key) {
        if (!obj) return false;
        if (obj[key] !== undefined && obj[key] !== null && obj[key] != "")
          return true;
        return false;
      }
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (obj[key] !== undefined && obj[key] !== null) return true;
        }
      }
      return false;
    },
    createArrayFromArray(seqProp, seq, srcArr) {
      let newArr = [];
      let q = {};
      q[seqProp] = null;
      seq.forEach((val) => {
        q[seqProp] = val;
        const el = _.find(srcArr, q);
        if (el) newArr.push(el);
      });
      return newArr;
    },
    routeGo(mutation, replaceMode = false, omitNullValues = false, justGetTheLink = false) {
      _log_("routeGo.as.", mutation);
      // this.$router.push(mutation);

      if (!mutation) return false;
      var newRoute = {
        // path: JSON.parse(JSON.stringify(this.$route.path)),
        name: JSON.parse(JSON.stringify(this.$route.name)),
        query: JSON.parse(JSON.stringify(this.$route.query)),
        params: JSON.parse(JSON.stringify(this.$route.params))
      };
      // if (mutation.path) newRoute.path = mutation.path;
      if (mutation.name) newRoute.name = mutation.name;
      if (mutation.query)
        for (const key in mutation.query) {
          if (mutation.query.hasOwnProperty(key)) {
            const element = mutation.query[key];
            if ((omitNullValues && element) || !omitNullValues)
              newRoute.query[key] = element;
            // else delete newRoute.query[key];
          }
        }
      if (mutation.params)
        for (const key in mutation.params) {
          if (mutation.params.hasOwnProperty(key)) {
            const element = mutation.params[key];
            _log_("routeGo.mutata param." + key, element);
            if ((omitNullValues && element) || !omitNullValues)
              newRoute.params[key] = element;
            // else delete newRoute.params[key];
          }
        }
      // if (!Object.entries(newRoute.params).length) delete newRoute.params;
      if (justGetTheLink)
        return this.$router.resolve(newRoute).href + "???";
      if (replaceMode)
        this.$router.replace(newRoute)
          .catch((e) => _log_(e.message));
      else this.$router.push(newRoute)
        .catch((e) => _log_(e.message));
    },
    grStrToNumber(val) {
      if (!val) return "";
      return parseFloat((val + "").replace(",", "."));
    },
    //accounting.....
    dateFromUnxTime(unix_timestamp, format) {
      if (!unix_timestamp) return;
      let date = new Date(unix_timestamp * 1000),
        o = "";

      const formatter = new Intl.DateTimeFormat("en-GB",
        (format && _.isString(format.indexOf) && format.indexOf("time") >= 0) ? {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",

            hour12: false,
            timeZone: "Europe/Athens"
          } :
          {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            timeZone: "Europe/Athens"
          });

      const formatted = formatter.format(date);
return formatted;

      let day = "0" + date.getDate();
      // Minutes part from the timestamp
      let month = "0" + (date.getMonth() + 1);
      // Seconds part from the timestamp
      let year = date.getFullYear();

      // Will display time in 10:30:23 format
      o += day.substr(-2) + "/" + month.substr(-2) + "/" + year;
      // Hours part from the timestamp
      if (format && _.isString(format.indexOf) && format.indexOf("time") >= 0) {
        let hours = date.getHours();
        // Minutes part from the timestamp
        let minutes = "0" + date.getMinutes();
        // Seconds part from the timestamp
        let seconds = "0" + date.getSeconds();

        // Will display time in 10:30:23 format
        o += " " + hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2);
      }
      return o;
    },
    async qPlaces(q) {
      // ="{postParams:{businessId:Transdraft.businessId},editable:true}"
      const r = await api.fetchProcessor("transdrafts/vuegetfieldoptions", {
        // businessId: this.Transdraft.businessId,
        for: "all",
        query: q,
        valueField: "place",
        labelField: "place"
      });

      return r.data.results;
    },
    async emailCall(call, method = "GET") {
      const tenant = this.userDomain == "travel2" ? "pytheas" : this.userDomain;
      const _token = await this.getApiAuthToken();
      let answer = null;
      let responseHook = await fetch(
        "https://api.safecontrol.gr/api/" + call,//email/" + emailId,
        {
          method,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "X-Tenant": tenant,
            "Content-Type": "application/json;charset=utf-8",
            Authorization: Api.token_type + " " + _token
          }
        }
      );
      try {
        answer = await responseHook.json();
        _log_("API.resend....", answer);
      } catch (e) {
      }
      return answer;
    },
    async getApiAuthToken() {
      const tenant = this.userDomain == "travel2" ? "pytheas" : this.userDomain;
      // _log_('get.. auth tenant',  this.userProfile)
      const _token = this.doYouRember("access_token") ? this.doYouRember("access_token") : Api.access_token;
      try {
        let auth = await fetch(
          "https://api.safecontrol.gr/auth/refresh",
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "X-Tenant": tenant,
              "Content-Type": "application/json;charset=utf-8",
              Authorization: Api.token_type + " " + _token
            }
          }
        );
        let _auth = await auth.json();
        Api.access_token = _auth.access_token;
        this.rememberIt("access_token", _auth.access_token);
        // _log_('get.. auth login', _auth, _auth.access_token, this.doYouRember('access_token'))
      } catch (error) {
        try {
          _log_("alternative auth login");
          let auth2 = await fetch(
            "https://api.safecontrol.gr/auth/refresh",
            {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                "X-Tenant": tenant,
                "Content-Type": "application/json;charset=utf-8",
                Authorization: Api.token_type + " " + Api.access_token
              }
            }
          );
          let _auth2j = await auth2.json();
          Api.access_token = _auth2j.access_token;
          this.rememberIt("access_token", Api.access_token);
          _log_("get.ALT. auth login", _auth2j, _auth2j.access_token, this.doYouRember("access_token"));
        } catch (error) {
          return false;
        }

      }
      return this.doYouRember("access_token");
    },
    async qTags(q) {
      var selectedBusiness = null;
      if (this.Transdraft && this.Transdraft.businessId)
        selectedBusiness = this.Transdraft.businessId;
      if (this.TransDraft && this.TransDraft.businessId)
        selectedBusiness = this.TransDraft.businessId;
      // ="{postParams:{businessId:Transdraft.businessId},editable:true}"
      const r = await api.fetchProcessor("transdrafts/vuegetfieldoptions", {
        businessId: selectedBusiness,
        for: this.$route.params.direction,
        query: q,
        valueField: "tags",
        labelField: "tags"
      });
      _log_("taggg..", r);
      return r.data.results;
    },

    //accounting.....end
    hasChange(what, val) {
      var compareThis = this.cachedSnapShots[what],
        cahcedVal = JSON.stringify(val),
        hasChanged = false;
      if (!compareThis) hasChanged = true;
      else if (compareThis != cahcedVal) hasChanged = true;
      this.cachedSnapShots[what] = cahcedVal;
      return hasChanged;
    },
    deepCompare(obj1, obj2) {
      const vm = this;
      _log_("personal..ctx..", obj1, obj2);
      obj1 = obj1 ? obj1 : {};
      obj2 = obj2 ? obj2 : {};
      let diffObj = Array.isArray(obj2) ? [] : {};
      Object.getOwnPropertyNames(obj2)
        .forEach(function(prop) {
          if (prop.indexOf("__") !== 0) {
            if (!!obj2[prop] && !!obj1[prop] && typeof obj2[prop] === "object") {
              _log_("personal..ctx.compare.", prop);
              diffObj[prop] = vm.deepCompare(obj1[prop], obj2[prop]);
              // if it's an array with only length property => empty array => delete
              // or if it's an object with no own properties => delete
              if (Array.isArray(diffObj[prop]) && Object.getOwnPropertyNames(diffObj[prop]).length === 1 || Object.getOwnPropertyNames(diffObj[prop]).length === 0) {
                delete diffObj[prop];
              }
            } else if (obj1[prop] !== obj2[prop]) {
              diffObj[prop] = obj2[prop];
            }
          }
        });
      return diffObj;
    },
    rightDrawerSize() {
      var w = window.innerWidth;
      try {
        document.createEvent("TouchEvent");
        return "100%";
      } catch (e) {
      }
      if (w > 1360) return "70%";
      if (w > 1000) return "95%";
      return "100%";
    },
    getAppContext() {
      // _log_("personal..ctx..", this.$route);
      return this.$route.name ? this.$route.name : "global";
    },
    rememberIt(key, val, incontext) {
      const ctxt = incontext ? incontext : this.getAppContext();
      // _log_('personal..stu..', key, val)
      var profile = window.localStorage.getItem("safecontrol_profile");
      if (profile) profile = JSON.parse(profile);
      else {
        profile = {};
        profile[ctxt] = {};
      }
      if (!profile[ctxt]) profile[ctxt] = {};
      profile[ctxt][key] = val;
      _log_("personal..aa..", profile);
      window.localStorage.setItem(
        "safecontrol_profile",
        JSON.stringify(profile)
      );

      return val;
    },
    doYouRember(key, defaultVal, incontext) {
      const ctxt = incontext ? incontext : this.getAppContext();
      // _log_('personal..get..', key)
      var profile = window.localStorage.getItem("safecontrol_profile");
      var val = defaultVal;
      if (profile) {
        profile = JSON.parse(profile);
        // _log_('personal..get.in.', profile)
        if (profile[ctxt]) {
          val =
            profile[ctxt][key] !== undefined && profile[ctxt][key] !== null
              ? profile[ctxt][key]
              : val;
        }
      }

      return val;
    },
    prependArrayElement(value, array) {
      var newArray = array.slice();
      newArray.unshift(value);
      return newArray;
    },
    formatNumber(number, decPlaces, decSep, thouSep) {
      // _log_('hel...', number)
      if (!number || number == "") return "";
      decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
      decSep = typeof decSep === "undefined" ? "," : decSep;
      thouSep = typeof thouSep === "undefined" ? "." : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(parseFloat(number)
        .toFixed(decPlaces));

      var parts = i.toString()
        .split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
      return parts.join(decSep);

      // var j = (j = i.length) > 3 ? j % 3 : 0;

      // const r = sign +
      //     (j ? i.substr(0, j) + thouSep : "") +
      //     i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
      //     (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
      // if (r + "" == 'NaN') return ''
      // return r
    },
    removeFromArray(repoArray, searchObject) {
      if (!repoArray) return;
      var o = null;
      var countProps = 0;
      var countCorrects = 0,
        foundIdx = null;
      // repoArray.forEach(element => {
      for (const [idx, element] of repoArray.entries()) {
        countProps = 0;
        countCorrects = 0;
        for (const key in searchObject) {
          if (searchObject.hasOwnProperty(key)) {
            ++countProps;
            const sval = searchObject[key];
            if (element[key] + "" == sval + "") ++countCorrects;
          }
        }
        if (countCorrects == countProps) {
          foundIdx = idx;
          o = element;
          break;
        }
      }

      if (o) repoArray.splice(foundIdx, 1);
      return repoArray;
      // _log_('oo go..', o, foundIdx)
    },
    updateArray(repoArray, searchObject, updateObject, cleanUpdate) {
      _log_("oo go.updateArray.", repoArray, searchObject, updateObject);
      if (!repoArray) return;
      var realUpdateObject = null;
      var countProps = 0;
      var countCorrects = 0,
        foundIdx = null;
      // repoArray.forEach(element => {
      for (const [idx, element] of repoArray.entries()) {
        countProps = 0;
        countCorrects = 0;
        for (const key in searchObject) {
          if (searchObject.hasOwnProperty(key)) {
            ++countProps;
            const sval = searchObject[key];
            if (element[key] + "" == sval + "") ++countCorrects;
          }
        }
        if (countCorrects == countProps) {
          foundIdx = idx;
          realUpdateObject = element;
          break;
        }
      }

      if (realUpdateObject) {
        if (cleanUpdate) realUpdateObject = updateObject;
        else
          for (const key in updateObject) {
            if (updateObject.hasOwnProperty(key)) {
              realUpdateObject[key] = updateObject[key];
            }
          }
        this.$set(repoArray, foundIdx, realUpdateObject);
      }
      return repoArray;
      // console.log('oo go..', o, foundIdx)
    },
    updateArrayElement(arrayTarget, element, idKey = "id", updateNullelement) {
      var qe = {};
      qe[idKey] = element[idKey];
      var idx = _.findIndex(arrayTarget, qe);
      if (idx >= 0) this.$set(arrayTarget, idx, element);
      // arrayTarget.$set(idx, element)
      else if (updateNullelement) {
        idx = -1;
        var cnt = 0;
        arrayTarget.forEach((element) => {
          if (!element[idKey]) {
            idx = cnt;
            return;
          }
          ++cnt;
        });
        // qe[idKey] = null
        // idx = _.findIndex(arrayTarget, qe)
        // console.log('hell..x.' + idx, arrayTarget, element)
        if (idx >= 0) this.$set(arrayTarget, idx, element);
      }
    },
    isWindowSize(wsize, andLarger = false) {
      const w = window.innerWidth;
      // console.log('check siz '+w)
      if (andLarger)
        switch (wsize) {
          case "mobile":
            try {
              document.createEvent("TouchEvent");
              return true;
            } catch (e) {
              return false;
            }
            break;
          case "xl":
            return w > 1920;
            break;
          case "lg":
            return w > 1200;
            break;
          case "md":
            return w > 992;
            break;
          case "sm":
            return w > 768;
            break;
          case "xs":
            return w > 640;
            break;
          default:
            return true;
            break;
        }
      else
        switch (wsize) {
          case "mobile":
            try {
              document.createEvent("TouchEvent");
              return true;
            } catch (e) {
              return false;
            }
            break;
          case "xl":
            return w > 1920;
            break;
          case "lg":
            return w <= 1920 && w > 1200;
            break;
          case "md":
            return w <= 1200 && w > 992;
            break;
          case "sm":
            return w <= 992 && w > 768;
            break;
          case "xs":
            return w <= 768;
            break;
          default:
            break;
        }
    },
    stringifyProp(repoArray, prop) {
      return repoArray.map((m) => {
        m[prop] = m[prop] ? m[prop].toString() : null;
        return m;
      });
    },

    isEmptyObject(val) {
      if (val === null || val === undefined) return true;
      if (val instanceof Object) return Object.keys(val).length === 0;
      if (Array.isArray(val)) return val.length > 0;
    },
    findInArray(repoArray, searchObject, index) {
      if (!repoArray) return;
      let o = null;
      let countProps = 0;
      let countCorrects = 0;
      let idx = 0, foundIdx = false;
      repoArray.forEach((element) => {
        if (element) {
          countProps = 0;
          countCorrects = 0;
          for (const key in searchObject) {
            if (searchObject.hasOwnProperty(key)) {
              ++countProps;
              const sval = searchObject[key];
              if (element[key] + "" == sval + "") ++countCorrects;
            }
          }
          if (countCorrects == countProps) {
            o = element;
            foundIdx = idx;
            return true;
          }
          ++idx;
        }
      });
      return index ? foundIdx : o;
    },
    findAllInArray(repoArray, searchObject) {
      if (!repoArray) return;
      var o = [];
      var countProps = 0;
      var countCorrects = 0;
      let idx = 0, foundIdx = false;
      repoArray.forEach((element) => {
        if (element) {
          countProps = 0;
          countCorrects = 0;
          for (const key in searchObject) {
            if (searchObject.hasOwnProperty(key)) {
              ++countProps;
              const sval = searchObject[key];
              if (element[key] + "" == sval + "") ++countCorrects;
            }
          }
          if (countCorrects == countProps) {
            o.push(element);
            foundIdx = idx;
            return true;
          }
          ++idx;
        }
      });
      return o;
    },
    createHashMap(key, prop, assets) {
      var themap = {};
      assets.forEach((element) => {
        themap[element[key]] = element[prop];
      });
      return themap;
    },
    vueSet(what, target) {
      if (what === null) {
        target = null;
        return null;
      }
      for (const key in what) {
        if (what.hasOwnProperty(key)) {
          const element = what[key];
          this.$set(target, key, element);
        }
      }
      return target;
    },
    $makeQueryParam(name) {
      let Q = {};
      Q[v] = {
        get() {
          return this.$route.query[name];
        },
        set(v) {
          let setter = {};
          setter[name] = v;
          this.routeGo({ query: setter });
        }
      };
    },
    inString(needle, heystack) {
      if (!heystack) return false;
      const heystackPrts = heystack.split(",");
      return heystackPrts.indexOf(needle) >= 0;
    },
    toggleElement: function(arrayData, toggleValue, asString) {
      var tglO = asString ? (arrayData ? arrayData.split(",") : []) : (arrayData ? arrayData : []);
      if (!tglO) {
        console.warn("No repo defined as :" + arrayName);
        return false;
      }
      var x = tglO.indexOf(toggleValue);
      if (x > -1) tglO.splice(x, 1);
      else tglO.push(toggleValue);
      return asString ? tglO.join(",") : tglO;
      //need to query objects
    },
    downloadFile(urlToSend, reqfilename) {
      var req = new XMLHttpRequest();
      req.open("GET", urlToSend, true);
      req.responseType = "blob";
      req.onload = function(event) {
        var blob = req.response;
        var fileName = reqfilename
          ? reqfilename
          : req.getResponseHeader("fileName"); //if you have the fileName header available
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      };

      req.send();
    },
    printElement(elem, title) {
      console.log("printElement", elem);
      let mywindow = window.open("", "PRINT");//, 'height=1400,width=1600');

      title = title || document.title;
      mywindow.document.write("<html><head><title>" + title + "</title>");
      // <link rel="stylesheet" href="/vueapp/css/quasar.css?t=[[timestamp]]"/>
      // <link rel="stylesheet" href="/vueapp/css/app.css?t=[[timestamp]]"/>
      // mywindow.document.write('<link rel="stylesheet" href="/vueapp/css/quasar.css"/>');
      mywindow.document.write("<link rel=\"stylesheet\" href=\"/vueapp/css/app.css\"/>");
      mywindow.document.write("</head><body >");
      // mywindow.document.write('<h1>' + title + '</h1>');
      mywindow.document.write(elem.innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      setTimeout(() => {
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();
      }, 800);


      return true;
    },
    //
    goPdf: function(url, data, reqfilename) {
      url = "/" + Travel.wdb.replace("_", "-") + url;
      console.log("goPdf..." + url);
      var postParams = [];
      for (const paramName in data) {
        if (data.hasOwnProperty(paramName)) {
          const element = data[paramName];
          postParams.push(paramName + "=" + element);
        }
      }

      if (postParams.length > 0) {
        url = url + "?" + postParams.join("&");
        if (reqfilename) this.downloadFile(url, reqfilename);
        else {
          // return;
          // window.location.assign(url);

          var win = window.open(url, "_blank");
          if (win)
            win.focus();
          else alert("A popup blocker does not allow the PDF to be displayed. Please adjust your permissions for this web app");
        }
      } else alert("Well i dont know what to print :(");
    },
    goBack(at) {
      console.log("go back  ", at);
      this.$router.go(-1);
      // if (!at) at = "/";
      // let rPrts = this.$route.path.split(at);
      // let url = rPrts[0];
      // if (at == "/") {
      //   rPrts.pop();
      //   url = rPrts.join(at);
      // }
      // console.log("hell...", at, url);
      // this.$router.push({ path: url });
    },
    returnBackToParent(extras) {
      console.log(
        "updateTable,returnBackToParent",
        this.$router.history.current.matched
      );
      if (
        this.$router.history.current.matched &&
        this.$router.history.current.matched[
        this.$router.history.current.matched.length - 2
          ]
      ) {
        let rt = extras ? extras : {};
        rt.name = this.$router.history.current.matched[
        this.$router.history.current.matched.length - 2
          ].name;

        this.routeGo(rt);
      }
      this.showRightModal = false;
    },
    removeArrayElement(arrayTarget, element, idKey = "id") {
      //
      var qe = {};
      qe[idKey] = element[idKey];
      var idx = _.findIndex(arrayTarget, qe);
      if (idx >= 0) this.$delete(arrayTarget, idx);
    },
    intToTime(val) {
      if (isNaN(val)) return val;
      if (!val || isNaN(val)) return "";
      val = Math.floor(val);
      const h = Math.floor(val / 60),
        m = val % 60;
      return (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m);
    },
    strTimeToInt(h, m) {
      if (!isNaN(h)) return h;
      if (m === undefined) {
        const prts = h.split(":");
        h = prts[0];
        m = prts[1];
      }
      return h * 60 + parseInt(m);
    },
    formatUnxTime(val, onlytime, onlydate) {
      if (isNaN(val) && val != "now") return "";
      var day = val == "now" ? moment() : moment.unix(val);
      if (onlytime) return day.format("HH:mm");
      if (onlydate) return day.format("DD/MM/YYYY");
      return day.format("DD/MM/YYYY HH:mm");
    },
    isMobileDevice() {
      // console.log('is mobile????')
      // return true;
      if ("ontouchstart" in document.documentElement) return true;
      if (window.innerWidth < 760) return true;
      return false;
    },
    isTouchDevice() {
      try {
        document.createEvent("TouchEvent");
        return true;
      } catch (e) {
        return false;
      }
    },
    uniqueKey(small) {
      if (!small) return Date.now() + Math.random();
      return (Date.now() + Math.random() * 10000000)
        .toString(36)
        .split(".")[0]
        .toUpperCase();
    },
    unxnow() {
      // var d=new Date()
      return Math.floor(Date.now() / 1000);
    },
    momentFormat(val, outFormat = "DD/MM/YYYY HH:mm") {
      console.log(">>>>" + val, outFormat);
      val = _.isNumber(val) ? val * 1000 : val;
      // const cd = new Date(val * 1000),
      const date = moment(val, _.isNumber(val) ? "X" : null);
      // console.log("hel o.momentFormat.", cd, date, date.format(format));
      return date.format(outFormat);
    },
    grToDate(val) {
      const dt = new Date();
      const prts = val.split("/");
      dt.setMonth(prts[1] - 1);
      dt.setDate(prts[0]);
      dt.setFullYear(prts[2]);
      return dt;
    },
    // formatMoney: amount => accounting.formatMoney(amount),
    formatDate: (val, format = "X") => {

      const date = moment(val, format);
// let w= date.utcOffset(countryTzUTCoffset).format("DD/MM/YY")
      return val && date.isValid() ? date.utcOffset(countryTzUTCoffset).format("DD/MM/YY") : "";
    },
    tooglePanels() {
      console.log("hell-o");
    },
    $theMoney(number, decPlaces, decSep, thouSep) {
      // if (_.isString(number)) number = parseFloat(number)

      decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces;
      decSep = typeof decSep === "undefined" ? "." : decSep;
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      return currency(number, { symbol: "", separator: thouSep, decimal: decSep, precision: decPlaces })
        .format();
      let sign = number < 0 ? "-" : "";
      let i = String(
        parseInt((number = Math.abs(Number(number) || 0)
          .toFixed(decPlaces)))
      );
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j)
          .replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces
          ? decSep +
          Math.abs(number - i)
            .toFixed(decPlaces)
            .slice(2)
          : "")
      );
    },
    formatList: (array) => _.map(array, (item) => item.value)
      .join(",")
  }
});

// import VueDataTables from 'vue-data-tables'
// Vue.use(VueDataTables)
